export default __webpack_public_path__ + "static/media/logo360.84a19688.png";